import React, { useRef, useEffect } from "react";
import { Rect, Text, Group, Line } from "react-konva";

const TimeRect = ({
  rect,
  index,
  fill,
  iterations,
  workingIteration,
  colorPickerVisible,
  readFill,
  readOpacity,
}) => {
  const timeTextRef = useRef();
  const lineRef = useRef();
  const textToDisplay = useRef();

  //convert the time in seconds to a readable format
  const convertTime = (time) => {
    let min = Math.floor(time / 60);
    let sec = time - min * 60;

    return min + ":" + (sec < 10 ? "0" : "") + parseFloat(sec).toFixed(2);
  };

  useEffect(() => {
    let hasCurrentIteration = null;
    if (rect.iterations) {
      hasCurrentIteration = rect.iterations.find(
        (o) => o.name === iterations[workingIteration]
      );
    }
    if (workingIteration === -1) {
      textToDisplay.current = `Start time: ${convertTime(rect.startTime)}`;
      return;
    }
    if (rect.iterations && hasCurrentIteration) {
      // I need to get the index of the iteration that matches the name
      // of the currently selected one, so I can assign the new time to it
      let index = rect.iterations.indexOf(hasCurrentIteration);
      textToDisplay.current = `${iterations[workingIteration]}: ${convertTime(
        rect.iterations[index].startTime
      )}`;
    } else
      textToDisplay.current =
        "Nothing assigned for " + iterations[workingIteration];
  }, [workingIteration, rect]);

  const fadeOut = () => {
    timeTextRef.current.to({
      opacity: 0.2,
      duration: 0.15,
    });
    if (rect.pauseAfter) {
      lineRef.current.to({
        opacity: 0.2,
        duration: 0.15,
      });
    }
  };

  const fadeIn = () => {
    timeTextRef.current.to({
      opacity: 1,
      duration: 0.15,
    });
    if (rect.pauseAfter) {
      lineRef.current.to({
        opacity: 1,
        duration: 0.15,
      });
    }
  };

  return (
    <>
      <Group
        x={rect.x}
        y={rect.y}
        onMouseEnter={() => {
          if (!colorPickerVisible) fadeOut();
        }}
        onMouseLeave={() => {
          if (!colorPickerVisible) fadeIn();
        }}
      >
        <Rect
          key={index}
          name={"rect"}
          id={String(index)}
          width={rect.width}
          height={rect.height}
          fill={colorPickerVisible ? readFill : fill}
          stroke="#000"
          strokeWidth={1}
          opacity={colorPickerVisible ? readOpacity : 0.5}
          selected={rect.selected}
        />
        <Text
          ref={timeTextRef}
          x={5}
          y={5}
          fontSize={15}
          fontStyle="bold"
          fill="#000"
          opacity={colorPickerVisible ? 0 : 1}
          stroke="#FFF"
          strokeWidth={3}
          fillAfterStrokeEnabled
          listening={false}
          text={textToDisplay.current}
        />
        {rect.pauseAfter && !colorPickerVisible && (
          <Line
            ref={lineRef}
            points={[rect.width - 3, 0, rect.width - 3, rect.height]}
            stroke="#ff0000"
            strokeWidth={6}
          />
        )}
      </Group>
    </>
  );
};

export default TimeRect;
